import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import { OrderedMap } from "immutable";
import ActiveFilters from "components/common/EntityFilters/ActiveFilters";
import FilterDropdown from "report/report-creation/content/filters/FilterDropdown";
import useFiltersWithTitle from "components/common/EntityFilters/hooks/useFiltersWithTitle";
import Button from "components/bootstrap/Button";
import Icon from "components/common/Icon";
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: 10px;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
`;
const ActiveFilterContainer = styled.div`
  display: flex;
  gap: 5px;
  margin-left: 5px;
`;
const ClearAllButton = styled(Button)`
  margin-left: 5px;
`;
const FiltersBar = ({ attributes, filters, setFilters }) => {
  const { data: activeFilters, onChange: onChangeFiltersWithTitle } = useFiltersWithTitle(
    filters,
    attributes,
    !!attributes
  );
  const onChangeFilters = useCallback(
    (newFilters) => {
      const newUrlQueryFilters = newFilters.entrySeq().reduce(
        (col, [attributeId, filterCol]) => {
          var _a;
          return col.set(attributeId, [...(_a = col.get(attributeId)) != null ? _a : [], ...filterCol.map(({ value }) => value)]);
        },
        OrderedMap()
      );
      onChangeFiltersWithTitle(newFilters, newUrlQueryFilters);
      setFilters(newUrlQueryFilters);
    },
    [onChangeFiltersWithTitle, setFilters]
  );
  const onChangeFilter = useCallback(
    (attributeId, prevValue, newFilter) => {
      const filterGroup = activeFilters.get(attributeId);
      const updatedFilterGroup = filterGroup.map(
        (oldFilter) => oldFilter.value === prevValue ? newFilter : oldFilter
      );
      onChangeFilters(activeFilters.set(attributeId, updatedFilterGroup));
    },
    [activeFilters, onChangeFilters]
  );
  const onCreateFilter = useCallback(
    (attributeId, filter) => {
      var _a;
      onChangeFilters(OrderedMap(activeFilters).set(attributeId, [...(_a = activeFilters == null ? void 0 : activeFilters.get(attributeId)) != null ? _a : [], filter]));
    },
    [activeFilters, onChangeFilters]
  );
  const onDeleteFilter = useCallback(
    (attributeId, filterId) => {
      const filterGroup = activeFilters.get(attributeId);
      const updatedFilterGroup = filterGroup.filter(({ value }) => value !== filterId);
      return onChangeFilters(
        updatedFilterGroup.length ? activeFilters.set(attributeId, updatedFilterGroup) : activeFilters.remove(attributeId)
      );
    },
    [activeFilters, onChangeFilters]
  );
  const clearFilters = useCallback(() => onChangeFilters(OrderedMap()), [onChangeFilters]);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Column, null, "Filters:"), /* @__PURE__ */ React.createElement(Column, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    FilterDropdown,
    {
      attribute: "owner",
      filterableAttributes: attributes,
      activeFilters,
      onCreateFilter
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "account_circle" }),
    "Created By"
  ), /* @__PURE__ */ React.createElement(
    FilterDropdown,
    {
      attribute: "_id",
      filterableAttributes: attributes,
      activeFilters,
      onCreateFilter
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "team_dashboard" }),
    " Dashboard"
  ), /* @__PURE__ */ React.createElement(ClearAllButton, { onClick: clearFilters, bsSize: "small" }, "Clear All")), activeFilters ? /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(ActiveFilterContainer, null, /* @__PURE__ */ React.createElement(
    ActiveFilters,
    {
      filters: activeFilters,
      attributes,
      onChangeFilter,
      onDeleteFilter,
      filterValueRenderers: {}
    }
  ))) : null));
};
export default FiltersBar;
